import {AbstractControl, UntypedFormControl, ValidationErrors} from '@angular/forms';
import * as moment from 'moment-timezone';

export function periodRepetitionValidator(group: AbstractControl): ValidationErrors | null {
  const scheduleType = group.get('scheduleMethod.scheduleType')?.value;
  const repetitionType = group.get('repetitionMethod.repetitionType')?.value;
  const startDate = group.get('scheduleMethod.period.start')?.value[0];
  const endDate = group.get('scheduleMethod.period.end')?.value[0];
  const isValid = scheduleType === 'period' && repetitionType !== 'noRepeat' && (Boolean(startDate) && Boolean(endDate));
  const isSameDate = moment(startDate).format('YYYY-MM-DD') !== moment(endDate).format('YYYY-MM-DD');

  return !(isValid && isSameDate) ? null : {message: 'Dates must be set within day'};
}


export function checkDiffDates(group: AbstractControl): ValidationErrors | null {
  const startDate = group.get('start')?.value[0];
  const endDate = group.get('end')?.value[0];

  if (Boolean(startDate) && Boolean(endDate)) {
    return moment(startDate, 'YYYY-MM-DD HH:mm').isAfter(moment(endDate, 'YYYY-MM-DD HH:mm')) ? {diffDates: 'End date must be after start date'} : null;
  }

  return null;
}

export function isHtml(control: UntypedFormControl): ValidationErrors | null  {
    const doc = new DOMParser().parseFromString(control.value, 'text/html');
    const isValid = Array.from(doc.body.childNodes).some(node => node.nodeType === 1);

    return isValid ? null : {isHtml: true};
}

export function passwordMatcher(control: AbstractControl): ValidationErrors | null {
  const isMatch = control.get('password')?.value === control.get('confirmPassword')?.value

  return isMatch ? null : {passwordMatch: true};
}
